







































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "./store/index";
import { getQueryVariable } from "./common/common";
// import Watermark from './components/Watermark.vue';
import Report from "./views/Report.vue";
// @ts-ignore
import i18n from "./language";

declare var productId: any;
declare var reportId: any;

export default Vue.extend({
	name: "app",
	data() {
		return {
			watermarkList: [],
			protocol: "",
			isOutline: "",
		};
	},
	computed: mapState({
		reportType: (state: any) => store.getters.getReportType,
		reportId: (state: any) => store.getters.getReportId,
		productId: (state: any) => store.getters.getProductId,
		checkType: (state: any) => store.getters.getCheckType,
		checkUrl: (state: any) => store.getters.getCheckUrl,
	}),
	components: {
		// Watermark,
		Report,
	},
	methods: {
		// 切换报告类型
		changeMenu(type: string) {
			this.$store.dispatch("setReportType", type);
			history.pushState(
				null,
				"",
				location.href.split("?")[0] +
					"?reportId=" +
					getQueryVariable("reportId") +
					"&productId=" +
					getQueryVariable("productId") +
					"&reportType=" +
					this.reportType +
					`${getQueryVariable("checkType") ? "&checkType=" + getQueryVariable("checkType") : ""}` +
					`${getQueryVariable("lang") ? "&lang=" + getQueryVariable("lang") : ""}`
			);
		},
		interceptor() {
			// 请求拦截器
			this.$http.interceptors.request.use((config: any) => {
				if (config.method === "get") {
					config.params = {
						_t: new Date().getTime(),
						...config.params,
					};
				}
				return config;
			});
			// 响应拦截器
			this.$http.interceptors.response.use(
				(response: any) => {
					if (response && response.status === 200) {
						if (response.request.responseType === "blob") {
							return response;
						}
						if (response.data.success) {
							return Promise.resolve(response.data);
						} else {
							return Promise.reject(response.data.message);
						}
					}
				},
				(error: any) => {
					if (error.response) {
						switch (error.response.status) {
							case 401:
								window.location.href = error.response.headers.location;
								break;
						}
					}
				}
			);
		},
	},
	created() {
		this.interceptor();
		this.$store.dispatch("setReportType", getQueryVariable("reportType"));
		this.$store.dispatch("setCheckType", getQueryVariable("checkType"));
		//更新产品id报告id
		this.$store.dispatch("setProductId", getQueryVariable("productId"));
		this.$store.dispatch("setReportId", getQueryVariable("reportId"));
		this.protocol = location.protocol;
		this.isOutline = getQueryVariable("outline");
		if (location.protocol === "file:") {
			this.$store.dispatch("setReportType", "fullText");
			history.pushState(
				null,
				"",
				location.href.split("?")[0] +
					"?reportId=" +
					reportId +
					"&productId=" +
					productId +
					"&reportType=" +
					this.reportType +
					`${getQueryVariable("checkType") ? "&checkType=" + getQueryVariable("checkType") : ""}`
			);
		}
	},
	mounted() {
		// 后腿更新视图
		window.addEventListener("popstate", (e: Event) => {
			this.$store.dispatch("setReportType", getQueryVariable("reportType"));
		});
	},
});
